module.exports = __webpack_public_path__ + "static/img/5.a024a2f8.png";